import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import styled from "styled-components/macro";
import { WxIcon, WxLabel } from "../../..";
import useMenu from "../../../../hooks/api/queries/useMenu";
import { useMenuContext } from "../../../../hooks/context/useMenuContext";
import { __ } from "../../../../i18n/l10n";
import { breakpoint } from "../../../../styles/constants";
import { SubMenu } from "../../subMenu/SubMenu";
import { MenuNav } from "../MenuNav";

export const MobileMenu: React.FC = () => {
  const { open, setOpen, selected } = useMenuContext();
  const { data: menu } = useMenu();

  if (!menu === undefined) return null;

  return (
    <Container open={open}>
      <TopContainer>
        <WxLabel label={__("Categories")} active black />
        <AbsoluteContainer>
          <WxIcon icon={faTimes} onClick={() => setOpen(false)} />
        </AbsoluteContainer>
      </TopContainer>
      {selected === -1 ? (
        <MenuNavContainer>
          <MenuNav />
        </MenuNavContainer>
      ) : (
        <SubMenuContainer>
          <SubMenu />
        </SubMenuContainer>
      )}
    </Container>
  );
};

const Container = styled.div<{ open: boolean }>`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  transform: translate(${({ open }) => (open ? "0" : "-100%")});
  @media (min-width: ${breakpoint}) {
    display: none;
  }
  transition: transform ease-out 250ms;
  width: 91%;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  background-color: ${({ theme }) => theme.colors.white};
  min-height: 100vh;
`;

const TopContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  padding: 2.2rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

const AbsoluteContainer = styled.div`
  position: absolute;
  right: 3.5%;
  top: 50%;
  transform: translate(0, -50%);
`;

const SubMenuContainer = styled.div`
  margin-left: 1.5rem;
  margin-top: 1.25rem;
`;

const MenuNavContainer = styled.div`
  margin: 2.4rem 1.7rem 0 1.5rem;
`;
